import React from "react";
import residentialImg from "../img/envision/about/aboutbanner.JPG";

const AboutBannerenvision = () => {
  return (
    <section style={{ backgroundColor: "#fff" }}>
      <div className="container-fluid" style={{ padding: "0px", overflow: "hidden", position: "relative",backgroundColor:'#fff' }}>
        <div className="row">
          <div className="col-lg-12" style={{ position: "relative" }}>
            <img
              src={residentialImg}
              alt="Residential Interiors"
              style={{ height: "750px", width: "100%", objectFit: "cover" }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "#fff",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                padding: "20px",
                borderRadius: "10px",
                textAlign: "center",
                maxWidth: "80%",
              }}
            >
              <h2 style={{ fontSize: "2rem", margin: "0" }}>Welcome to Our Story</h2>
              <p style={{ fontSize: "1.2rem", marginTop: "10px" }}>
                Discover our journey and achievements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBannerenvision;
